import { type FC, Suspense, useLayoutEffect } from 'react';
import { Outlet } from 'react-router';
import { appStarted } from '~/entities/auth';
import { initStore } from '~/shared/lib/storage';
import { AppLoader } from '../AppLoader';
import { useAuthQuerySync } from './lib';

export const BaseLayout: FC = () => {
    useAuthQuerySync();

    useLayoutEffect(() => {
        initStore().then(() => {
            appStarted();
        });
    }, []);

    return (
        <Suspense fallback={<AppLoader />}>
            <Outlet />
        </Suspense>
    );
};
